module.exports = __webpack_public_path__ + "img/tabs-bg-1.35473d78.png";